import { testDataCreator } from '@wix/answers-lib';
import { SatisfactionRatingType, CsatStatus, CsatChannel } from '.';
import { RandomGenerator } from '../../test-utils';
var CustomizedRatingResponsesBuilder = /** @class */ (function () {
    function CustomizedRatingResponsesBuilder() {
        var _a;
        this.customizedRatingResponses = (_a = {},
            _a[SatisfactionRatingType.POSITIVE] = {
                responseMessage: 'positive response',
                followUpMessage: 'positive followup',
                responseMessageEnabled: true,
                followUpMessageEnabled: true,
            },
            _a[SatisfactionRatingType.NEUTRAL] = {
                responseMessage: 'neutral response',
                followUpMessage: 'neutral followup',
                responseMessageEnabled: true,
                followUpMessageEnabled: true,
            },
            _a[SatisfactionRatingType.NEGATIVE] = {
                responseMessage: 'negative response',
                followUpMessage: 'negative followup',
                responseMessageEnabled: true,
                followUpMessageEnabled: true,
            },
            _a);
    }
    CustomizedRatingResponsesBuilder.prototype.withCustomizedPositiveResponse = function (content) {
        this.customizedRatingResponses[SatisfactionRatingType.POSITIVE] = content;
        return this;
    };
    CustomizedRatingResponsesBuilder.prototype.withCustomizedNeutralResponse = function (content) {
        this.customizedRatingResponses[SatisfactionRatingType.NEUTRAL] = content;
        return this;
    };
    CustomizedRatingResponsesBuilder.prototype.withCustomizedNegativeResponse = function (content) {
        this.customizedRatingResponses[SatisfactionRatingType.NEGATIVE] = content;
        return this;
    };
    CustomizedRatingResponsesBuilder.prototype.build = function () {
        return this.customizedRatingResponses;
    };
    return CustomizedRatingResponsesBuilder;
}());
export { CustomizedRatingResponsesBuilder };
// tslint:disable-next-line: max-classes-per-file
var CsatContentBuilder = /** @class */ (function () {
    function CsatContentBuilder() {
        this.csatContent = {
            customerCommentEnabled: true,
            customizedRatingResponses: new CustomizedRatingResponsesBuilder().build(),
            feedbackReceivedMessage: 'feedback received',
            ratingRequestMessage: 'rating request',
        };
    }
    CsatContentBuilder.prototype.withCustomerCommentEnabled = function (customerCommentEnabled) {
        this.csatContent.customerCommentEnabled = customerCommentEnabled;
        return this;
    };
    CsatContentBuilder.prototype.withCustomizedRatingResponses = function (customizedRatingResponses) {
        this.csatContent.customizedRatingResponses = customizedRatingResponses;
        return this;
    };
    CsatContentBuilder.prototype.withFeedbackReceivedMessage = function (feedbackReceivedMessage) {
        this.csatContent.feedbackReceivedMessage = feedbackReceivedMessage;
        return this;
    };
    CsatContentBuilder.prototype.withRatingRequestMessage = function (ratingRequestMessage) {
        this.csatContent.ratingRequestMessage = ratingRequestMessage;
        return this;
    };
    CsatContentBuilder.prototype.build = function () {
        return this.csatContent;
    };
    return CsatContentBuilder;
}());
export { CsatContentBuilder };
// tslint:disable-next-line: max-classes-per-file
var CsatBuilder = /** @class */ (function () {
    function CsatBuilder() {
        this.csat = {
            // Using Channel enum from '../tickets' causes cyclic dependency and breaks
            channel: 160,
            csatStatus: CsatStatus.WAITING,
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            agentId: '',
            id: '',
            ticketId: ''
        };
    }
    CsatBuilder.prototype.withChannel = function (channel) {
        this.csat.channel = channel;
        return this;
    };
    CsatBuilder.prototype.withCsatStatus = function (csatStatus) {
        this.csat.csatStatus = csatStatus;
        return this;
    };
    CsatBuilder.prototype.withCreationDate = function (creationDate) {
        this.csat.creationDate = creationDate;
        return this;
    };
    CsatBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.csat.lastUpdateDate = lastUpdateDate;
        return this;
    };
    CsatBuilder.prototype.withAgentId = function (agentId) {
        this.csat.agentId = agentId;
        return this;
    };
    CsatBuilder.prototype.withId = function (id) {
        this.csat.id = id;
        return this;
    };
    CsatBuilder.prototype.withTicketId = function (ticketId) {
        this.csat.ticketId = ticketId;
        return this;
    };
    CsatBuilder.prototype.build = function () {
        return this.csat;
    };
    return CsatBuilder;
}());
export { CsatBuilder };
// tslint:disable-next-line: max-classes-per-file
var CSatLocalizedSettingsBuilder = /** @class */ (function () {
    function CSatLocalizedSettingsBuilder() {
        var _a, _b;
        this.localeSettings = {
            channels: (_a = {},
                _a[CsatChannel.API_EMAIL_HELP_CENTER] = true,
                _a[CsatChannel.CALL_CENTER] = true,
                _a[CsatChannel.CHAT] = true,
                _a[CsatChannel.WHATSAPP] = true,
                _a[CsatChannel.FACEBOOK] = true,
                _a[CsatChannel.SMS] = true,
                _a[CsatChannel.TWITTER] = true,
                _a[CsatChannel.INSTAGRAM] = true,
                _a),
            facebookInvitationMessage: '',
            smsInvitationMessage: '',
            whatsappInvitationMessage: '',
            twitterInvitationMessage: '',
            instagramInvitationMessage: '',
            supportedFeatures: (_b = {},
                _b[CsatChannel.API_EMAIL_HELP_CENTER] = true,
                _b[CsatChannel.CALL_CENTER] = true,
                _b[CsatChannel.CHAT] = true,
                _b[CsatChannel.WHATSAPP] = true,
                _b[CsatChannel.FACEBOOK] = true,
                _b[CsatChannel.SMS] = true,
                _b[CsatChannel.TWITTER] = true,
                _b[CsatChannel.INSTAGRAM] = true,
                _b),
            csatContent: new CsatContentBuilder().build()
        };
    }
    CSatLocalizedSettingsBuilder.prototype.withChannel = function (channel, value) {
        this.localeSettings.channels[channel] = value;
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.withTenantEnabledChannel = function (channel, value) {
        this.localeSettings.supportedFeatures[channel] = value;
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.withSupportedFeatures = function (channels) {
        this.localeSettings.supportedFeatures = channels;
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.withRandomChannels = function () {
        var _this = this;
        [
            CsatChannel.API_EMAIL_HELP_CENTER,
            CsatChannel.CALL_CENTER,
            CsatChannel.CHAT,
            CsatChannel.WHATSAPP,
            CsatChannel.FACEBOOK,
            CsatChannel.SMS,
            CsatChannel.TWITTER,
            CsatChannel.INSTAGRAM
        ].forEach(function (channel) {
            _this.localeSettings.channels[channel] = Math.random() > 0.5;
        });
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.withWhatsAppInvitationMessage = function (message) {
        this.localeSettings.whatsappInvitationMessage = message;
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.withFacebookInvitationMessage = function (message) {
        this.localeSettings.facebookInvitationMessage = message;
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.withTwitterInvitationMessage = function (message) {
        this.localeSettings.twitterInvitationMessage = message;
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.withInstagramInvitationMessage = function (message) {
        this.localeSettings.instagramInvitationMessage = message;
        return this;
    };
    CSatLocalizedSettingsBuilder.prototype.build = function () {
        return this.localeSettings;
    };
    return CSatLocalizedSettingsBuilder;
}());
export { CSatLocalizedSettingsBuilder };
// tslint:disable-next-line: max-classes-per-file
var CSatDefaultValuesBuilder = /** @class */ (function () {
    function CSatDefaultValuesBuilder() {
        this.values = {
            'csat-survey.customer-comments.negative-followup': "How can we do better?",
            'csat-survey.customer-comments.negative-response': "We're sorry to hear that",
            'csat-survey.customer-comments.neutral-followup': "Is there anything we can improve?",
            'csat-survey.customer-comments.neutral-response': "Your opinion matters",
            'csat-survey.customer-comments.positive-followup': "Do you have anything to add?",
            'csat-survey.customer-comments.positive-response': "Happy we could help!",
            'csat-survey.feedback-received-message': "Thank you for your feedback!",
            'csat-survey.rating-request-message': "How would you rate your overall chat experience?",
        };
    }
    CSatDefaultValuesBuilder.prototype.withNegativeValues = function (followup, response) {
        return this.withCustomerCommentsValues('negative', followup, response);
    };
    CSatDefaultValuesBuilder.prototype.withNeutralValues = function (followup, response) {
        return this.withCustomerCommentsValues('neutral', followup, response);
    };
    CSatDefaultValuesBuilder.prototype.withPositiveValues = function (followup, response) {
        return this.withCustomerCommentsValues('positive', followup, response);
    };
    CSatDefaultValuesBuilder.prototype.withCustomerCommentsValues = function (type, followup, response) {
        this.values["csat-survey.customer-comments.".concat(type, "-response")] = response;
        this.values["csat-survey.customer-comments.".concat(type, "-followup")] = followup;
        return this;
    };
    CSatDefaultValuesBuilder.prototype.withRatingRequestMessage = function (msg) {
        this.values["csat-survey.rating-request-message"] = msg;
        return this;
    };
    CSatDefaultValuesBuilder.prototype.withFeedbackReceivedMessage = function (msg) {
        this.values["csat-survey.feedback-received-message"] = msg;
        return this;
    };
    CSatDefaultValuesBuilder.prototype.build = function () {
        return this.values;
    };
    return CSatDefaultValuesBuilder;
}());
export { CSatDefaultValuesBuilder };
export var CsatConditionBuilder = testDataCreator(function () { return ({
    name: RandomGenerator.name,
    disabled: RandomGenerator.randomBoolean(),
    mustConditions: [],
    itemType: RandomGenerator.randomNumber(0, 100),
}); });
//# sourceMappingURL=builders.js.map